import script from "./AboutSection.vue?vue&type=script&setup=true&lang=js"
export * from "./AboutSection.vue?vue&type=script&setup=true&lang=js"

import "./AboutSection.vue?vue&type=style&index=0&id=494e839b&scoped=true&lang=scss"

import exportComponent from "/Users/kadir.aslan/Projects/Repositories/Personal/kadiraslan-de/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-494e839b"]])

export default __exports__